"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getWritingDir = void 0;
const constants_1 = require("../constants");
const getWritingDir = (language) => constants_1.RTL_LANGUAGES.includes(language) ? 'rtl' : 'ltr';
exports.getWritingDir = getWritingDir;
